
export enum AchievementTriggerTypes {
    unit = 'unit',
    points = 'points',
    daysSinceLastUnit = 'days_since_last_unit',
    correctAnswersPercent = 'correct_answers_percent',
}